import { AnchorHTMLAttributes, ReactElement } from "react";
import { useUser } from "../functional-components/UserContext";
import { cockpitEditUrl } from "../utils/CmsUtils";
import Icon from "./Icon";
import { useBjelinTranslations } from "../hooks/TranslationHooks";
import { useLang } from "../hooks/LangHooks";

const CockpitEditLink = ({
  collection,
  labelKey,
  _id,
  lang: _lang,
  wrapper = children => <div className={"text-center"}>{children}</div>,
  ...linkProps
}: {
  collection: string;
  _id?: string;
  labelKey?: string;
  lang?: string;
  wrapper?: (children: ReactElement) => ReactElement;
} & Partial<AnchorHTMLAttributes<HTMLAnchorElement>>) => {
  const t = useBjelinTranslations();
  const curLang = useLang();
  const lang = _lang ?? curLang;
  const { admin } = useUser();
  return admin
    ? wrapper(
        <a
          href={cockpitEditUrl(collection, _id, lang)}
          target="_blank"
          rel="noopener noreferrer"
          {...linkProps}
        >
          {t(labelKey ?? "Edit")} <Icon name="pen-to-square" />
        </a>
      )
    : null;
};

export default CockpitEditLink;
